export default "__VITE_ASSET__DZEw5oqB__"